export enum DateTimeKind {
    UKNOWN = 'UKNOWN',
    UTC = 'UTC',
    AGENCY = 'agency-local'
}